import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { jobOffer } from 'job/model/job-offer.fragments';
import { JobOfferOutput } from 'job/model/job-offer.output';

import { ApiQuery } from '../../../../common/model/api.query';

export interface FetchJobOfferByIdParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class FetchJobOfferByIdApiQuery extends ApiQuery<
	JobOfferOutput,
	FetchJobOfferByIdParams
> {
	client = 'iam';
	document = gql`
		query FetchJobOfferById($id: UUID!) {
			fetchJobOfferById(id: $id) {
				...JobOffer
			}
		}
		${jobOffer}
	`;
	method = 'fetchJobOfferById';
}
